'use strict'

import Vue from 'vue'

import router from 'Router'
import store from 'Store'
import App from './App.vue'

import 'Utils/Validator'
import 'Utils/NoReact'
import 'Utils/CompArr'

import Alerts from 'Plugins/Alerts'

Vue.use(Alerts)

import ApiService from 'Services/ApiService'
import AuthService from 'Services/AuthService'

Vue.config.productionTip = false


ApiService.init()
AuthService.init(router)


const app = new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})
